<template>
  <VForm @submit.prevent="save">
    <VRow no-gutters>
      <VCol cols="12">
        <VTextField
          v-model="password"
          class="mb-3"
          :label="$t('currentPass')"
          outlined
          dense
          type="password"
          autocomplete="current-password"
          :error-messages="errors.password"
        />

        <VTextField
          v-model="newPassword"
          class="mb-3"
          :label="$t('newPass')"
          outlined
          dense
          type="password"
          autocomplete="new-password"
          :error-messages="errors.newPassword"
        />

        <VTextField
          v-model="newPasswordConfirmation"
          class="mb-3"
          :label="$t('confirmPass')"
          outlined
          dense
          type="password"
          autocomplete="new-password"
          :error-messages="errors.newPasswordConfirmation"
        />
      </VCol>
    </VRow>
    <VRow justify="center" no-gutters>
      <VCol v-if="hasErrorMessageOnly" cols="12" md="6" class="red--text text-center mb-6">
        {{ errorMessage }}
      </VCol>
      <VCol cols="12" class="text-center">
        <VBtn
          color="success"
          dark
          elevation="0"
          type="submit"
          :loading="loading"
        >
          {{ $t('changePass') }}
        </VBtn>
      </VCol>
    </VRow>
  </VForm>
</template>

<script>
import ValidationMixin from '../mixins/ValidationMixin';
import User from '../orm/models/User/User';

export default {
  name: 'UserChangePasswordForm',
  mixins: [ValidationMixin],
  data() {
    return {
      password: '',
      newPassword: '',
      newPasswordConfirmation: '',
      loading: false,
    };
  },
  methods: {
    async save() {
      await this.withValidationHandling(async () => {
        await User.api().changePassword({
          password: this.password,
          newPassword: this.newPassword,
          newPasswordConfirmation: this.newPasswordConfirmation,
        });
        this.$toast.success(this.$t('passChanged'));
      });
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  currentPass: Current password
  newPass: New password
  confirmPass: Confirm password
  changePass: Change password
  passChanged: Password was changed
</i18n>

<i18n locale="ru" lang="yaml">
  currentPass: Текущий пароль
  newPass: Новый пароль
  confirmPass: Подтверждение пароля
  changePass: Изменить пароль
  passChanged: Пароль изменен
</i18n>
